import { i18n } from '@/plugins/i18n';

export default {
  lastUpdate: function (date) {
    if (date) {
      // date = date.replace('T', ' ');
      // if (navigator.userAgent.match(/(iPhone|iPod|iPad)/) != null) {
      //   var dateParts = date.substring(0, 10).split('-');
      //   var timePart = date.substring(11);
      //   date =
      //     dateParts[1] +
      //     '/' +
      //     dateParts[2] +
      //     '/' +
      //     dateParts[0] +
      //     ' ' +
      //     timePart;
      // }
      let today = new Date();
      let lastUpdate = new Date(date);
      //console.log('Last update lastUpdate:', lastUpdate);
      let diffMinutes = (today.getTime() - lastUpdate.getTime()) / (1000 * 60);
      // check if deali is in days
      const dayDuration = 60 * 24;
      if (diffMinutes > dayDuration) {
        let diff = Math.round(diffMinutes / dayDuration);
        if (diff === 1) return diff + ' ' + i18n.tc('general.day');
        return diff + ' '+i18n.tc('general.days');
      }

      const hourDuration = 60;
      if (diffMinutes > hourDuration) {
        let diff = Math.round(diffMinutes / hourDuration);
        if (diff === 1) return diff + ' ' + i18n.tc('general.hour');
        return diff + ' ' + i18n.tc('general.hours');
      }
      let diff = Math.round(diffMinutes);
      if (diff === 1) return diff + ' ' + i18n.tc('general.minute');
      return Math.round(diffMinutes) + ' ' + i18n.tc('general.minutes');
    } else {
      return '-';
    }
  },

  getInitials(name, min = 0, max = 2) {
    if(name && name.length > 0) {
      name = name.trim();
      if (!name) return ' ';
      let initials = name.trim().match(/\b(\w)/g);
      if( !initials) return '';
      return initials.slice(min, max).join('');
    }
    return '';
  },

  isValidEmail(check) {
    let checkMail = check.trim();
    if (checkMail.indexOf('<') > -1 && checkMail.indexOf('>') > -1) {
      checkMail = checkMail.substr(
        checkMail.indexOf('<') + 1,
        checkMail.indexOf('>') - checkMail.indexOf('<') - 1
      );
    }
    const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
    return reg.test(checkMail);
  },
};
